import { PracticeProgramCardData } from '@/types/curriculum-program.type';
import {
  CurriculumStepItem,
  RecommendClassCautionsData,
} from './recommend-class.data';

// 2주 완성 무제한 카드 데이터
export const week2UnlimitedData: PracticeProgramCardData = {
  subtitle: '2주간 무제한 연습',
  title: '2주완성 무제한',
  checkListItems: [
    '단기간에 빨리 면허 따야 하는 분',
    '기본 감각 있고 빠른 실전 대비 원하는 분',
    '집중형·속성 수업이 맞는 분',
  ],
  prices: [
    { type: '2종보통 자동', price: '20만원' },
    { type: '1종보통 자동', price: '22만원' },
    { type: '1종보통 수동', price: '24만원' },
  ],
};

// 한달 완성 무제한 카드 데이터
export const monthUnlimitedData: PracticeProgramCardData = {
  subtitle: '한달간 무제한 연습',
  title: '한달완성 무제한',
  checkListItems: [
    '처음이라 기초부터 천천히 배우고 싶은 분',
    '불안감 많아 반복 연습이 필요한 분',
    '시간 여유 있게 차근차근 실력 쌓고 싶은 분',
  ],
  prices: [
    { type: '2종보통 자동', originalPrice: '35만원', price: '32만원' },
    { type: '1종보통 자동', originalPrice: '37만원', price: '34만원' },
    { type: '1종보통 수동', originalPrice: '39만원', price: '36만원' },
  ],
  discountBanner: '수험생 인증 시 3만원할인!',
  discountAmount: 30000,
};

export const unlimitedCurriculumSteps: CurriculumStepItem[] = [
  {
    stepNumber: 1,
    title: '기초 조작',
    imageSrc: '/images/recommend-class/unlimited/step_01_img.png',
    imageAlt: '기초 조작 시뮬레이터',
    description:
      '실차 부품 100% 구현! 와이퍼부터 전조등, 방향지시등, 기어변속까지 실전 감각을 살리는 안전한 운전연수!',
    operations: [
      '좌석 미러 세팅',
      '시동 ON/OFF, 출발 정지',
      '와이퍼 전조등 방향지시등 조작',
      '(1종) 클러치·변속기 사용법',
    ],
  },
  {
    stepNumber: 2,
    title: '기본 주행',
    imageSrc: '/images/recommend-class/unlimited/step_02_img.png',
    imageAlt: '기본 주행 시뮬레이터',
    description:
      '실제 주행 흐름에 따라 가속, 감속, 방향 전환 등 기본적인 주행 감각을 익히는 단계',
    operations: [
      '브레이크 · 엑셀 감 익히기',
      '차체감 익히기 (차선 맞추기)',
      '좌 · 우 회전 및 핸들 익히기',
    ],
  },
  {
    stepNumber: 3,
    title: '장내기능 시험',
    imageSrc: '/images/recommend-class/unlimited/step_03_img.png',
    imageAlt: '장내기능 시험 시뮬레이터',
    description:
      '시험장 코스 기준으로 경사로, 직각 주차 등 기능시험 항목을 반복 연습 하는 단계',
    operations: [
      '코스 및 주요 규정 숙지',
      'T자 주차',
      '가속 구간',
      '반복 연습',
    ],
  },
  {
    stepNumber: 4,
    title: '도로주행 시험',
    imageSrc: '/images/recommend-class/unlimited/step_04_img.png',
    imageAlt: '도로주행 시험 시뮬레이터',
    description:
      '차선변경, 신호인식, 교차로우회전 등 도로주행시험 항목을 반복 연습 하는 단계',
    operations: [
      '코스 및 주요 규정 숙지',
      '차선 변경',
      '교차로 우회전',
      '반복 연습',
    ],
  },
];

export const unlimitedCautionData: RecommendClassCautionsData = {
  title: '2주완성 할인 프로모션 주의사항',
  items: [
    {
      parts: [{ text: '- 모든 이용료는 부가세 별도입니다.' }],
    },
    {
      parts: [
        { text: '- ' },
        { text: '[2주완성 무제한]', bold: true },
        { text: ' 의 유효기간은 ' },
        { text: '[14일]', bold: true },
        { text: ' 입니다.' },
      ],
    },
    {
      parts: [
        { text: '- ' },
        { text: '[2주완성 무제한]', bold: true },
        { text: '은 3회차까지 ' },
        { text: '[한달완성무제한]', bold: true },
        { text: '으로 변경 가능하며 추가금액이 발생합니다.' },
      ],
    },
    {
      parts: [
        { text: '- ' },
        { text: '[한달완성 무제한]', bold: true },
        { text: ' , ' },
        { text: '[합격무제한]', bold: true },
        { text: ' 이용권은 ' },
        { text: '2주 단위로 연장이 가능합니다.', bold: true },
      ],
    },
    {
      parts: [
        { text: '- ' },
        { text: '[2주완성 무제한]', bold: true },
        { text: ' 은 이용권 연장이 불가합니다.' },
      ],
    },
    {
      parts: [
        { text: '- ' },
        { text: '[합격무제한]', bold: true },
        { text: ' 의 유효기간은 ' },
        { text: '[2개월]', bold: true },
        { text: ' 입니다.' },
      ],
    },
    {
      parts: [
        { text: '- 2주 연장 시 (2종) ' },
        { text: '70,000원', bold: true },
        { text: ', (1종) ' },
        { text: '90,000원', bold: true },
        {
          text: '의 추가 비용(부가세 별도)이 발생됩니다. 단, 유효기간 연장은 기존 수강기간 내에 신청하여야 합니다. (기간 종료 후 추가연장 불가)',
        },
      ],
    },
    {
      parts: [
        {
          text: '- 본 할인은 1인 1회 구매가로, 본인 이용만 가능하며 타인과 공유 및 양도할 수 없습니다.',
        },
      ],
    },
    {
      parts: [
        {
          text: '- 본 이벤트는 지점별 사정에 따라 조기 중단 또는 변경될 수 있으니 사전 문의 바랍니다.',
        },
      ],
    },
  ],
};
